import React from 'react';
import Sidebar from './Sidebar';
import Footer from './Footer';
import MobileHeader from './MobileHeader';
import ScrollProgress from './ScrollProgress';
import useVisitorAccentColor from '../hooks/useVisitorAccentColor';
export default function Layout({ children }) {
  const accentColor = useVisitorAccentColor();

  return (
    <div
      className="lg:flex bg-cream-100 min-h-screen"
      style={{ '--visitor-accent': accentColor }}
    >
      <ScrollProgress />
      {/* Desktop sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>
      {/* Mobile/Tablet header */}
      <MobileHeader />
      <div className="flex-1 flex flex-col min-w-0">
        <main className="flex-1 px-4 py-5 sm:px-6 sm:py-6 lg:px-10 lg:py-8 page-enter">{children}</main>
        <Footer />
      </div>
    </div>
  );
}
